export enum CODES {
  TOKEN_NOT_VALID = "token_not_valid",
  INVALID_OR_EXPIRED_TOKEN = "INVALID_OR_EXPIRED_TOKEN",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  PERMISSION_DENIED = "PERMISSION_DENIED",
  AUTH_SERVICE_ERROR = "AUTH_SERVICE_ERROR",
  MEMBER_VERITICATION_ERROR = "MEMBER_VERITICATION_ERROR",
  MEMBERS_VERITICATION_ERROR = "MEMBERS_VERITICATION_ERROR",
  NO_DOCUMENTS_PROVIDED = "NO_DOCUMENTS_PROVIDED",
  PROJECT_NOT_FOUND = "PROJECT_NOT_FOUND",
  PROJECT_ACCESS_DENIED = "PROJECT_ACCESS_DENIED",
  PROJECT_UPDATE_ERROR = "PROJECT_UPDATE_ERROR",
  PROJECT_CREATION_ERROR = "PROJECT_CREATION_ERROR",
  FORUM_NOT_FOUND = "FORUM_NOT_FOUND",
  FORUM_MEMBER_ALREADY_EXISTS = "FORUM_MEMBER_ALREADY_EXISTS",
  FORUM_OWNER_REQUIRED = "FORUM_OWNER_REQUIRED",
  FORUM_INACTIVE_MEMBER = "FORUM_INACTIVE_MEMBER",
  TASK_NOT_FOUND = "TASK_NOT_FOUND",
  TASK_UPDATE_ERROR = "TASK_UPDATE_ERROR",
  TASK_DELETE_ERROR = "TASK_DELETE_ERROR",
  TASK_CREATION_ERROR = "TASK_CREATION_ERROR",
  RESOURCE_NOT_FOUND = "RESOURCE_NOT_FOUND",
  RESOURCE_ACCESS_DENIED = "RESOURCE_ACCESS_DENIED",
  RESOURCE_UPDATE_ERROR = "RESOURCE_UPDATE_ERROR",
  RESOURCE_DELETE_ERROR = "RESOURCE_DELETE_ERROR",
  RESOURCE_CREATION_ERROR = "RESOURCE_CREATION_ERROR",
  DOCUMENT_NOT_FOUND = "DOCUMENT_NOT_FOUND",
  DOCUMENT_UPLOAD_ERROR = "DOCUMENT_UPLOAD_ERROR",
  DOCUMENT_UPDATE_ERROR = "DOCUMENT_UPDATE_ERROR",
  DOCUMENT_DELETE_ERROR = "DOCUMENT_DELETE_ERROR",
  DOCUMENT_CREATION_ERROR = "DOCUMENT_CREATION_ERROR",
  INVALID_TOKEN = "INVALID_TOKEN",
  TOKEN_REQUIRED = "TOKEN_REQUIRED",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  USER_ALREADY_EXISTS = "USER_ALREADY_EXISTS",
  LOG_NOT_FOUND = "LOG_NOT_FOUND",
  LOG_CREATION_ERROR = "LOG_CREATION_ERROR",
  TRANSACTION_ERROR = "TRANSACTION_ERROR",
  EXTERNAL_SERVICE_ERROR = "EXTERNAL_SERVICE_ERROR",
}

export enum SUCCESS_CODE {
  SUCCESS = "SUCCESS",
}
